module.exports = __webpack_public_path__ + "img/delivery-truck.c90a232d.png";